<template>
  <div style="display: flex; height: 700px">
    <div style="width: 60%" ref="chart"></div>
    <MyTownSwiper style="width: 40%" v-bind:townInfo="townInfo"></MyTownSwiper>
  </div>
</template>
<script>
const echarts = require("echarts");
import MyTownSwiper from "./TownSwiper";
export default {
  components: {
    MyTownSwiper,
  },
  name: "MapEcharts",
  data() {
    return {
      batchId: "",
      areaData: [],
      townInfo: "湘江基金小镇",
      huNan: require("./MapJson/HuNan.json"), //地图json数据
      cityCode: {
        214: "长沙市",
        215: "株洲市",
        216: "湘潭市",
        217: "衡阳市",
        218: "邵阳市",
        219: "岳阳市",
        220: "常德市",
        221: "张家界市",
        222: "益阳市",
        223: "郴州市",
        224: "永州市",
        225: "怀化市",
        226: "娄底市",
        227: "湘西土家族苗族自治州",
      },
      option: {},
      center: {
        长沙市: [112.982279, 28.19409],
        湘潭市: [112.944052, 27.82973],
        株洲市: [113.151737, 27.835806],
        衡阳市: [112.607693, 26.900358],
        邵阳市: [111.46923, 27.237842],
        岳阳市: [113.132855, 29.37029],
        常德市: [111.691347, 29.040225],
        张家界市: [110.479921, 29.127401],
        益阳市: [112.355042, 28.570066],
        郴州市: [113.032067, 25.793589],
        永州市: [111.608019, 26.434516],
        怀化市: [109.97824, 27.550082],
        娄底市: [112.008497, 27.728136],
        湘西土家族苗族自治州: [109.739735, 28.314296],
      },
    };
  },
  methods: {
    init(huNan) {
      let myChart = echarts.init(this.$refs.chart);
      window.onresize = function () {
        myChart.resize();
      };
      echarts.registerMap("huNan", huNan);
      this.option = {
        visualMap: {
          show: false,
          max: 90,
          seriesIndex: [3],
          inRange: {
            color: ["#A5DCF4", "#006edd"],
          },
        },
        geo: [
          {
            map: "huNan",
            roam: false, //是否允许缩放
            zoom: 1.1, //默认显示级别
            scaleLimit: {
              min: 0,
              max: 3,
            }, //缩放级别
            itemStyle: {
              areaColor: "#013C62",
              shadowColor: "#013C62",
              shadowBlur: 20,
              shadowOffsetX: -5,
              shadowOffsetY: 15,
            },
            tooltip: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            z: 5,
            data: [
              {
                city: "长沙市",
                value: [111.982279, 28.59409],
                info: "长沙基金小镇",
              },
              {
                city: "长沙市",
                value: [111.582279, 28.29409],
                info: "长沙基金小镇3",
              },
              {
                city: "长沙市",
                value: [111.9282279, 28.99409],
                info: "长沙基金小镇5",
              },
            ],
            symbolSize: 14,
            label: {
              show: false,
              formatter: function (params) {
                return (
                  // "{fline|地点：" +
                  // params.data.city +
                  // "}\n{tline|" +
                  // (params.data.info || "XX基金小镇") +
                  // "}"
                  " " + params.data.info + " " || "XX基金小镇"
                );
              },
              position: "top",
              backgroundColor: "rgba(254,174,33,.8)",
              padding: [0, 0],
              borderRadius: 3,
              lineHeight: 32,
              color: "#f7fafb",
              rich: {
                fline: {
                  padding: [0, 10, 10, 10],
                  color: "#ffffff",
                },
                tline: {
                  padding: [10, 10, 0, 10],
                  color: "#ffffff",
                },
              },
            },
            itemStyle: {
              color: "#feae21",
            },
            emphasis: {
              label: {
                show: true,
              },
            },
          },
          {
            //红色小镇圆点
            type: "effectScatter",
            coordinateSystem: "geo",
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            z: 5,
            data: [
              {
                city: "株洲市",
                value: [113.151737, 27.835806],
                info: "株洲基金小镇",
              },
            ],
            symbolSize: 14,
            label: {
              show: false,
              formatter: function (params) {
                return (
                  // "{fline|地点：" +
                  // params.data.city +
                  // "}\n{tline|" +
                  // (params.data.info || "XX基金小镇") +
                  // "}"
                  " " + params.data.info + " " || "XX基金小镇"
                );
              },
              position: "top",
              backgroundColor: "rgba(233,63,66,.9)",
              padding: [0, 0],
              borderRadius: 3,
              lineHeight: 32,
              color: "#ffffff",
              rich: {
                fline: {
                  padding: [0, 10, 10, 10],
                  color: "#ffffff",
                },
                tline: {
                  padding: [10, 10, 0, 10],
                  color: "#ffffff",
                },
              },
            },
            itemStyle: {
              color: "#e93f42",
            },
            emphasis: {
              label: {
                show: true,
              },
            },
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            z: 5,
            data: [
              {
                city: "长沙市",
                value: [112.96371037301637, 28.24216980708771],
                info: "湘江基金小镇",
              },
            ],
            symbolSize: 14,
            label: {
              show: false,
              formatter: function (params) {
                return (
                  // "{fline|地点：" +
                  // params.data.city +
                  // "}\n{tline|" +
                  // (params.data.info || "XX基金小镇") +
                  // "}"
                  " " + params.data.info + " " || "XX基金小镇"
                );
              },
              position: "top",
              backgroundColor: "rgba(8,186,236,.9)",
              padding: [0, 0],
              borderRadius: 3,
              lineHeight: 32,
              color: "#ffffff",
              rich: {
                fline: {
                  padding: [0, 10, 10, 10],
                  color: "#ffffff",
                },
                tline: {
                  padding: [10, 10, 0, 10],
                  color: "#ffffff",
                },
              },
            },
            itemStyle: {
              color: "#08baec",
            },
            emphasis: {
              label: {
                show: true,
              },
            },
          },
          //地图
          {
            type: "map",
            mapType: "huNan",
            geoIndex: -1,
            zoom: 1.1, //默认显示级别
            label: {
              show: true,
              color: "#ffffff",
            },
            itemStyle: {
              borderColor: "#40a9ed",
              borderWidth: 1,
              areaColor: "#12235c",
            },
            emphasis: {
              itemStyle: {
                areaColor: "#fcdc58",
                borderWidth: 0,
              },
              label: {
                color: "white",
                show: false,
              },
            },
            data: Object.keys(this.center).map((name) => {
              return {
                name: name,
                value: Math.random() * 100,
              };
            }),
          },
        ],
      };
      myChart.setOption(this.option);
      myChart.on("click", (params) => {
        //点击圆点事件
        if (params.data.info) {
          this.TownInfo(params.data);
        } else {
          //点击地图城市
          console.log(this.findKey(this.cityCode, params.name));
        }
      });
    },
    TownInfo(params) {
      //调接口
      this.townInfo = params.info;
    },
    //取对象值
    findKey(obj, value, compare = (a, b) => a === b) {
      return Object.keys(obj).find((k) => compare(obj[k], value));
    },
  },
  mounted() {
    this.init(this.huNan);
  },
};
</script>

